module.exports = __webpack_public_path__ + "static/img/4b1c7984c207c22b66e633255687dea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_01.png
// module id = 6Jfb
// module chunks = 1